<!-- ===== HEADER ===== -->
<div class="header-container">
  <!-- Row 1: Back, Title, PO Badge, Selected Info, Spacer, Buttons -->
  <div class="po-header__row-1">
    <button mat-icon-button class="po-header__back-btn" (click)="close()" matTooltip="Back">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <h4 class="header-title">{{isEditMode ? 'Edit Purchase Order' : 'Create Purchase Order'}}</h4>

    @if (isEditMode && purchaseOrderData?.po_number) {
      <span class="po-number-badge">
        <span class="po-number-badge__hash">#</span>{{purchaseOrderData?.po_number}}
      </span>
    }

    @if (materialList?.length) {
      <span class="po-header__selected-divider"></span>
    }
    @if (materialList?.length) {
      <span class="po-header__selected-info">
        {{getSelectedCount()}} items selected
        @if (getSelectedValue()) {
          <span>&middot; {{getSelectedValue() | currency:'USD'}}</span>
        }
      </span>
    }

    <span class="po-header__spacer"></span>

    @if (vendorGroupList?.length) {
      <button type="button" class="btn cancel-btn" (click)="close()">Cancel</button>
    }
    @if (vendorGroupList?.length) {
      <!-- Nothing left to buy: the action reserves the warehouse stock instead of ordering it. -->
      <button type="button" class="btn add-purchase-order-button" (click)="save(purchaseForm)"
              [disabled]="poReserving"
              [matTooltip]="poNothingToOrder
                ? 'Every selected material is covered by warehouse stock, so no purchase order is needed. This reserves that stock for the job.'
                : ''">
        <mat-icon class="po-save-icon">{{poNothingToOrder ? 'inventory_2' : 'save'}}</mat-icon>
        @if (poNothingToOrder) {
          Reserve Stock
        } @else {
          {{isEditMode ? 'Update Purchase Order' : 'Create Purchase Order'}}
        }
      </button>
    }
  </div>

  <!-- Row 2: Job, Scope, Vendor, Vendor Quote, Toggles, Dates, Discount -->
  <div class="po-header__row-2">
    <!-- Group 1: Job/Scope/Vendor/VendorQuote -->
    <div class="po-header__group">
      <!-- Job Field - Hidden when creating from vendor quote -->
      @if (!isFromVendorQuote) {
        <div class="po-header__field po-header__field--job">
          <div class="inline-container">
            <!-- Regular Job -->
            @if (purchaseOrderObject.type==='regular') {
              <app-scrollable-search-field [disabled]="isEditMode" style="width: 100%;" id="customer_id"
                [dataService]="purchaseOrderService" [dataServiceFunctionName]="'search'"
                [searchPlaceHolder]="'Select Job'" [labelKey]="'name'"
                [formDataMapper]="{'id': 'id', 'name' : 'name'}" [keyNameToShowWhenSelected]="'name'"
                [additionalParams]="jobAdditionalParams"
                (selectedValueChange)="selectedValueChange($event,'job')" searchPlaceHolder="Job"
                [inputVal]="jobDetail" [ngClass]="{'disabled-field': isEditMode}">
              </app-scrollable-search-field>
            }
            <!-- Bulk Job -->
            @if (purchaseOrderObject.type==='bulk') {
              <app-scrollable-multiple-search-field [disabled]="isEditMode" style="width: 100%;" id="customer_id"
                [dataService]="purchaseOrderService" [dataServiceFunctionName]="'search'"
                [searchPlaceHolder]="'Select Job'" [labelKey]="'name'"
                [formDataMapper]="{'id': 'id', 'name' : 'name'}" [keyNameToShowWhenSelected]="'name'"
                [additionalParams]="jobAdditionalParams"
                (selectedValueMultipleChange)="selectedValueChange($event,'job')" searchPlaceHolder="Job"
                [inputVal]="jobDetail" [multiple]="true" [ngClass]="{'disabled-field': isEditMode}">
              </app-scrollable-multiple-search-field>
            }
          </div>
        </div>
      }

      <!-- Scope Field for Regular - Hidden when creating from vendor quote -->
      @if (purchaseOrderObject.type==='regular' && !isFromVendorQuote) {
        <div class="po-header__field po-header__field--scope"
          >
          <div class="inline-container" [ngClass]="{'edit-mode-scope': isEditMode}">
            <app-scrollable-multiple-search-field style="width: 100%;" id="scope_regular"
              [dataService]="purchaseOrderService" [dataServiceFunctionName]="'scopeSearch'"
              [searchPlaceHolder]="'Select Scope(s)'" [labelKey]="'scope_name'"
              [formDataMapper]="{'scope_name':'scope_name','job_scope_ids':'job_scope_ids'}"
              [keyNameToShowWhenSelected]="'scope_name'" [additionalParams]="scopeAdditionalParam"
              (selectedValueMultipleChange)="selectedValueChange($event,'scope')"
              (selectedValueClear)="selectedValueClear($event,'scope')"
              searchPlaceHolder="Scope"
              [inputVal]="scopeName"
              [multiple]="true"
              [showError]="false">
            </app-scrollable-multiple-search-field>
          </div>
        </div>
      }

      <!-- Scope Field for Bulk - Hidden when creating from vendor quote -->
      @if (purchaseOrderObject.type==='bulk' && !isFromVendorQuote) {
        <div class="po-header__field po-header__field--scope"
          >
          <div class="inline-container" [ngClass]="{'edit-mode-scope': isEditMode}">
            <app-scrollable-multiple-search-field style="width: 100%;" id="customer_id"
              [dataService]="purchaseOrderService" [dataServiceFunctionName]="'scopeSearch'"
              [searchPlaceHolder]="'Select Scope'" [labelKey]="'scope_name'"
              [formDataMapper]="{'scope_name':'scope_name','job_scope_ids':'job_scope_ids'}"
              [keyNameToShowWhenSelected]="'scope_name'" [additionalParams]="scopeAdditionalParam"
              (selectedValueMultipleChange)="selectedValueChange($event,'scope')" (selectedValueClear)="selectedValueClear($event,'scope')" searchPlaceHolder="Scope"
              [inputVal]="scopeName"
              [showError]="false">
            </app-scrollable-multiple-search-field>
          </div>
        </div>
      }

      <!-- Vendor field -->
      <div class="po-header__field po-header__field--vendor">
        <div class="inline-container">
          <!-- Multiple vendor selection for bulk -->
          @if (purchaseOrderObject.type==='bulk') {
            <app-scrollable-multiple-search-field style="width: 100%;" id="vendor_bulk"
              [dataService]="purchaseOrderService" [dataServiceFunctionName]="'vendorSearch'"
              [searchPlaceHolder]="'Select Vendor(s)'" [labelKey]="'vendor_name'"
              [formDataMapper]="{'vendor_id': 'vendor_id', 'vendor_name' : 'vendor_name'}"
              [keyNameToShowWhenSelected]="'vendor_name'" [additionalParams]="{jobids:jobId}"
              (selectedValueMultipleChange)="selectedValueChange($event,'vendor')"  (selectedValueClear)="selectedValueClear($event,'vendor')" searchPlaceHolder="Vendor"
              [inputVal]="vendorDetail" [multiple]="true"
              [showError]="false"
              [disabled]="isFromVendorQuote">
            </app-scrollable-multiple-search-field>
          }

          <!-- Vendor selection for regular PO and vendor-based PO -->
          @if (purchaseOrderObject.type==='regular' || purchaseOrderObject.type==='vendor') {
            <!-- CREATE MODE: When from vendor quote, show disabled field with pre-selected vendor -->
            @if (!isEditMode && isFromVendorQuote) {
              <div style="width: 100%;" class="vendor-quote-field">
                <mat-form-field appearance="outline" style="width: 100%;" class="vendor-readonly-field">
                  <mat-label>Vendor</mat-label>
                  <input matInput [value]="vendorName" disabled style="color: #000;">
                </mat-form-field>
              </div>
            }
            <!-- Normal vendor selection for job-based PO -->
            @if (!isEditMode && !isFromVendorQuote) {
              <app-scrollable-multiple-search-field style="width: 100%;" id="vendor_regular_create"
                [dataService]="purchaseOrderService" [dataServiceFunctionName]="'vendorSearch'"
                [searchPlaceHolder]="'Select Vendor(s)'" [labelKey]="'vendor_name'"
                [formDataMapper]="{'vendor_id': 'vendor_id', 'vendor_name' : 'vendor_name'}"
                [keyNameToShowWhenSelected]="'vendor_name'" [additionalParams]="{jobids:jobId}"
                (selectedValueMultipleChange)="selectedValueChange($event,'vendor')"  (selectedValueClear)="selectedValueClear($event,'vendor')" searchPlaceHolder="Vendor"
                [inputVal]="vendorDetail" [multiple]="true"
                [showError]="false">
              </app-scrollable-multiple-search-field>
            }
            <!-- EDIT MODE: Keep existing single vendor selection -->
            @if (isEditMode) {
              <app-scrollable-search-field style="width: 100%;" id="vendor_regular_edit"
                [dataService]="purchaseOrderService" [dataServiceFunctionName]="'vendorSearch'"
                [searchPlaceHolder]="'Select Vendor'" [labelKey]="'vendor_name'"
                [formDataMapper]="{'vendor_id': 'vendor_id', 'vendor_name' : 'vendor_name'}"
                [keyNameToShowWhenSelected]="'vendor_name'" [additionalParams]="{jobids:jobId}"
                (selectedValueChange)="selectedValueChange($event,'vendor')" searchPlaceHolder="Vendor"
                [inputVal]="vendorName"
                [showError]="false">
              </app-scrollable-search-field>
            }
          }
        </div>
      </div>

      <!-- Vendor Quote field -->
      @if (isFromVendorQuote) {
        <div class="po-header__field po-header__field--vendor-quote">
          <div class="inline-container">
            <app-scrollable-multiple-search-field style="width: 100%;" id="vendor_quote_select"
              [dataService]="purchaseOrderService" [dataServiceFunctionName]="'vendorQuoteSearch'"
              [searchPlaceHolder]="'Select Vendor Quote(s)'" [labelKey]="'quotation_reference'"
              [formDataMapper]="{'id': 'id', 'quotation_reference' : 'quotation_reference'}"
              [keyNameToShowWhenSelected]="'quotation_reference'"
              [additionalParams]="vendorQuoteAdditionalParam"
              (selectedValueMultipleChange)="selectedValueChange($event,'vendorQuote')"
              (selectedValueClear)="selectedValueClear($event,'vendorQuote')"
              searchPlaceHolder="Vendor Quote"
              [inputVal]="vendorQuoteList"
              [multiple]="true"
              [showError]="false">
            </app-scrollable-multiple-search-field>
          </div>
        </div>
      }
    </div>

    <!-- Group 2: Toggles + Dates (separated) -->
    @if (purchaseOrderObject.type !== 'vendor' && !isFromVendorQuote) {
      <div class="po-header__group po-header__group--separated">
        <!-- Price Engineering Toggle -->
        <div class="po-header__toggle">
          <mat-slide-toggle [checked]="false" [(ngModel)]="purchaseOrderObject.price_engineering_flag"
          class="toggle_switch toggle_switch_new" (ngModelChange)="priceEngineeringToggle()">Price Engineering</mat-slide-toggle>
        </div>
        <!-- Exclude Date Toggle -->
        <div class="po-header__toggle">
          <mat-slide-toggle [checked]="false" [ngModelOptions]="{standalone:true}"
            (ngModelChange)="onChangeExcludeDate($event)" [(ngModel)]="exclude_date_boolean"
          class="toggle_switch toggle_switch_new">Exclude Date</mat-slide-toggle>
        </div>
        <!-- Date Pickers -->
        <div class="po-header__dates">
          <div class="position-relative">
            <input matInput [matDatepicker]="picker1" [(ngModel)]="fromDate" (ngModelChange)="dateChange()"
              (click)="picker1.open()" class="form-control input-with-icon po-header__date-input" placeholder="From" />
            <mat-datepicker-toggle matIconSuffix [for]="picker1" class="icon-inside-input">
              <img src="assets/img/calendar.png" matDatepickerToggleIcon alt="Calendar" />
            </mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </div>
          <span class="po-header__date-separator">to</span>
          <div class="position-relative">
            <input matInput [matDatepicker]="picker2" (ngModelChange)="dateChange()" [(ngModel)]="toDate"
              (click)="picker2.open()" class="form-control input-with-icon po-header__date-input" placeholder="To" />
            <mat-datepicker-toggle matIconSuffix [for]="picker2" class="icon-inside-input">
              <img src="assets/img/calendar.png" matDatepickerToggleIcon alt="Calendar" />
            </mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
          </div>
        </div>
      </div>
    }

    <!-- Vendor Discount moved to the top of the right panel, above Vendor PO Summary —
         it is about the vendor orders built there, and it freed this row. -->
  </div>
</div>

<!-- The Vendor Discount trigger and its menu, rendered at the top of the right panel through
     `vendorDiscountTpl`. Kept as one template so the trigger and `#menu` stay together. -->
<ng-template #vendorDiscountTpl>
      <div class="po-header__discount">
        <span class="d-flex align-items-center cursor-pointer"
                [ngClass]="{
                    'po-header__discount--has-discount': (discountList?.length || 0) > 0,
                    'po-header__discount--confetti': showDiscountConfetti
                }"
          [matMenuTriggerFor]="menu">
          <mat-icon>sell</mat-icon>
          <span class="po-header__discount-label">Vendor Discount</span>
        </span>

        <!-- `class`, not `panelClass`. MatMenu declares this input as
             `panelClass: ["class", "panelClass"]` — it is aliased to `class`,
             so writing `panelClass="..."` only sets a dead attribute on
             <mat-menu>, which renders nothing. The overlay never received the
             class, which is why every rule written for this panel has been
             unreachable and it fell back to Material's defaults. -->
        <mat-menu #menu="matMenu" class="custom-menu-panel">
          <!-- Show discounts if available -->
          @for (item of discountList; track item; let d = $index) {
            <div class="discount-container"
              (click)="$event.stopImmediatePropagation()">
              <div class="d-flex justify-content-between pl-3">
                <div class="pb-2 pt-2 discount-left-side">
                  <div class="pb-2 text-info">{{item?.vendor_name}} has the discount available</div>
                  <div class="pt-1 discount-amount font-bold">{{item?.vendor_discount_threshold|currency:'USD'}}
                  </div>
                  <div class="discount-total_amount pt-2">Total Amount</div>
                </div>
                <div class="discount-right-side d-flex align-items-center">
                  <div>
                    <!-- The id must be unique per row. It was a literal
                         "checkbox-18" inside this loop, so every vendor's label
                         pointed at the first vendor's input — clicking any row
                         but the first toggled the wrong discount, and the custom
                         round control could not track state. -->
                    <div class="checkbox-wrapper-18">
                      <div class="round">
                        <input type="checkbox" [id]="'discount-checkbox-' + d"
                          [disabled]="materialList?.length>0?false:true"
                          (ngModelChange)="selectVendorDiscount($event, item)"
                          [(ngModel)]="item.isSelected" [ngModelOptions]="{standalone:true}" />
                        <label [attr.for]="'discount-checkbox-' + d"></label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }

          <!-- Show message when no discounts available -->
          @if (!discountList || discountList.length === 0) {
            <div class="no-discounts-container py-2">
              <div class="text-center py-2 px-2">
                <div class="no-discount-icon mb-2">
                  <img src="../../../../assets/img/general_icons/shoppingmode_grey.svg"
                    alt="No Discounts"
                    style="width: 32px; height: 32px; opacity: 0.5;">
                </div>
                <div class="no-discount-text">
                  <p class="mb-1" style="color: #666; font-size: 14px; font-weight: 500;">
                    No Vendor Discounts Available
                  </p>
                  <p class="mb-0" style="color: #999; font-size: 12px;">
                    No discounts are currently offered
                  </p>
                </div>
              </div>
            </div>
          }
        </mat-menu>
      </div>
</ng-template>

<!-- ===== BODY: Three-Panel Layout ===== -->
<div class="po-body material-container">

  <!-- Left Panel — Collapsed Strip -->
  @if (showMaterialPanel && isMaterialContainerCollapsed) {
    <div class="po-left-panel po-left-panel--collapsed"
      (click)="isMaterialContainerCollapsed = false">
      <mat-icon class="po-left-panel__collapsed-icon">inventory_2</mat-icon>
      <span class="po-left-panel__collapsed-label">Materials</span>
      <mat-icon class="po-left-panel__collapsed-expand">chevron_right</mat-icon>
    </div>
  }

  <!-- Left Panel — Material Selector (Expanded) -->
  @if (showMaterialPanel && !isMaterialContainerCollapsed) {
    <div class="po-left-panel">
      <!-- Header -->
      <div class="po-left-panel__header"
        (click)="isMaterialContainerCollapsed = true">
        <div class="po-left-panel__title-row">
          <mat-icon class="po-left-panel__icon">inventory_2</mat-icon>
          <span class="po-left-panel__title">Materials</span>
          @if (getSelectedMaterialCount()) {
            <span class="po-left-panel__count-badge">
              {{getSelectedMaterialCount()}} selected
            </span>
          }
          <mat-icon class="po-left-panel__collapse-chevron">chevron_left</mat-icon>
        </div>
        <!-- Search -->
        <div class="po-left-panel__search">
          <mat-icon class="po-left-panel__search-icon">search</mat-icon>
          <input type="text" placeholder="Search materials..."
            [(ngModel)]="materialSearchQuery" [ngModelOptions]="{standalone:true}"
            class="po-left-panel__search-input">
          @if (materialSearchQuery) {
            <button class="po-left-panel__search-clear"
              (click)="materialSearchQuery = ''" type="button">
              <mat-icon>close</mat-icon>
            </button>
          }
        </div>
      </div>
      <!-- Filter row -->
      <div class="po-left-panel__filters">
        <select class="po-left-panel__vendor-filter" [(ngModel)]="leftPanelVendorFilter" [ngModelOptions]="{standalone:true}">
          <option value="">All Vendors</option>
          @for (v of vendorList; track v) {
            <option [value]="v.vendor_id || v.id">{{v.vendor_name || v.name}}</option>
          }
        </select>
        <button class="po-left-panel__ready-toggle" type="button"
          [class.po-left-panel__ready-toggle--active]="showReadyOnly"
        (click)="showReadyOnly = !showReadyOnly">Ready Only</button>
      </div>
      <!-- Material list grouped by job -->
      <div class="po-left-panel__list">
        @for (entry of materialsByJob | keyvalue; track trackByJobKey($index, entry)) {
          <div class="po-left-panel__job-group">
            <!-- Job header -->
            <button class="po-left-panel__job-header" (click)="toggleJobExpand(entry.key)">
              <mat-icon class="po-left-panel__chevron" [class.po-left-panel__chevron--expanded]="isJobExpanded(entry.key)">chevron_right</mat-icon>
              <mat-icon class="po-left-panel__folder-icon">folder</mat-icon>
              <span class="po-left-panel__job-name">{{entry.key}}</span>
              <span class="po-left-panel__job-count">{{entry.value.length}}</span>
              @if (getSelectedCountInJob(entry.key)) {
                <span class="po-left-panel__job-selected-count">
                  {{getSelectedCountInJob(entry.key)}}
                </span>
              }
            </button>
            <!-- Materials under job -->
            @if (isJobExpanded(entry.key)) {
              <div class="po-left-panel__materials">
                @for (mat of entry.value; track mat; let i = $index) {
                  <div
                    class="po-left-panel__material-item"
                    [class.po-left-panel__material-item--selected]="mat.isSelected"
                    (click)="selectedMaterial(!mat.isSelected, mat, i)">
                    <mat-checkbox [checked]="mat.isSelected" class="po-left-panel__mat-check bidone-checkbox"
                      (click)="$event.stopPropagation()"
                    (change)="selectedMaterial($event.checked, mat, i)"></mat-checkbox>
                    <div class="po-left-panel__material-info">
                      <div class="po-left-panel__material-code">
                        {{mat?.product_code || mat?.material_code}}
                        <span class="po-left-panel__status-badge"
                                          [ngClass]="{'po-left-panel__status-badge--ready': mat?.status === 'ready-to-order' || mat?.is_ready_to_order,
                                                       'po-left-panel__status-badge--approved': mat?.status === 'approved' || mat?.is_approved}">
                          {{(mat?.status === 'ready-to-order' || mat?.is_ready_to_order) ? 'READY' : (mat?.is_approved ? 'APPROVED' : 'PENDING')}}
                        </span>
                      </div>
                      <div class="po-left-panel__material-name">{{mat?.product_name}}</div>
                      <div class="po-left-panel__material-meta">
                        <mat-icon class="po-left-panel__vendor-icon">business</mat-icon>
                        <span>{{mat?.vendor_name}}</span>
                        <span>&middot;</span>
                        <span>{{mat?.quantity}} avail</span>
                        <span>&middot;</span>
                        <span class="po-left-panel__material-cost">{{mat?.unit_price | currency:'USD'}}</span>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
        <!-- Empty state -->
        @if (!materialList?.length) {
          <div class="po-left-panel__empty">
            <mat-icon>inventory_2</mat-icon>
            <p>Select job & scope to load materials</p>
          </div>
        }
      </div>
      <!-- Footer summary -->
      @if (getSelectedMaterialCount()) {
        <div class="po-left-panel__footer">
          <span>{{getSelectedMaterialCount()}} materials</span>
          <span class="po-left-panel__footer-value">{{getSelectedMaterialValue() | currency:'USD'}}</span>
        </div>
      }
    </div>
  }

  <!-- Center Panel -->
  <div class="po-center-panel">
    <form novalidate #purchaseForm="ngForm">

      <div class="po-center-panel__table-section">
        <div class="table-responsive">
          <table class="table table-bordered table-purchase-order" style="width:100%">
            <thead>
              <tr>
                <!-- Same padding with or without Price Engineering: the PE value used to add 10px of
                     bottom padding here, which made the whole header row taller when toggled on. -->
                <th scope="col" style="padding: 10px 10px 0px 10px">
                  <!-- One `class`: this element carried two, so the second replaced the first and
                       the select-all box lost `bidone-checkbox`. It then fell back to Material's
                       prebuilt indigo-pink accent while every row below it was brand orange. -->
                  <mat-checkbox [disabled]="purchaseOrderObject.group_material_flag"
                    class="example-margin bidone-checkbox pr-3" [(ngModel)]="allMaterialSelected"
                    [indeterminate]="someSelected"
                    (ngModelChange)="allMaterialSelection($event)"
                  [ngModelOptions]="{standalone:true}"></mat-checkbox>
                </th>
                <th scope="col">JOB NO </th>
                <th scope="col">MATERIAL </th>
                <th scope="col">VENDOR(S)</th>
                <th scope="col">SCOPES</th>
                <!-- Req 9: free warehouse stock, replacing the job scope item's quantity_on_hand,
                     which was never warehouse stock and read as though it were. -->
                <th scope="col">IN WAREHOUSE</th>
                <th scope="col" class="po-table__th-center">ORDER QTY</th>
                <th scope="col" class="po-table__th-right">UNIT COST</th>
                <!-- Req 8: the quote this line is priced from; added, changed or removed here. -->
                <th scope="col">VENDOR QUOTE</th>
                <th scope="col" class="po-table__th-right">CONTRACT COST </th>
                <th scope="col">EST. VENDOR TAX</th>
                @if (purchaseOrderObject.price_engineering_flag) {
                  <!-- One header row: PREVIOUS / NEW sit in it directly instead of a second
                       sub-header row under a "PRICE ENGINEERING" span, which doubled the header height. -->
                  <th scope="col" class="po-pe__th" matTooltip="Price Engineering · line total before">PE PREVIOUS</th>
                  <th scope="col" class="po-pe__th" matTooltip="Price Engineering · the new line total">PE NEW</th>
                }
                <th scope="col" class="po-table__actions-th"></th>
              </tr>
            </thead>
            <tbody>
              @for (item of materialList; track item; let i = $index) {
                <tr class="table-content" [class.row-selected]="item.isSelected">
                  <td [ngStyle]="{'background-color': item.color}" class="text-black">
                    <mat-checkbox [(ngModel)]="item.isSelected" class="example-margin bidone-checkbox"
                      (ngModelChange)="selectedMaterial($event,item,i)"
                      [disabled]="purchaseOrderObject.group_material_flag"
                      [name]="'is_selected_' + i" [id]="'is_selected_' + i"
                    [ngModelOptions]="{standalone: true}"></mat-checkbox>
                  </td>
                  <td class="text-black" [ngStyle]="{'background-color': item?.color}">
                    <span class="po-table__job-cell">{{item?.job_number}}</span></td>
                    <td class="text-black" [ngStyle]="{'background-color': item?.color}">
                      <div class="po-table__material-cell">
                        <span class="po-table__material-code">{{item?.product_name}}</span>
                        @if (item.__fromQuote) {
                          <span class="po-fromq" matTooltip="Added from the vendor quote. Tick it to order it on this PO.">From quote</span>
                        }
                      </div>
                    </td>
                    <td class="text-black" [ngStyle]="{'background-color': item?.color}">
                      <div [matMenuTriggerFor]="menu"
                        (menuOpened)="getVendorPricing(item.vendor_id, item.material_id || item.product_id || item.id, item)"
                        class="d-flex align-items-center vendor_dropdown po-table__vendor-trigger">
                        <span>{{item?.vendor_name}}</span>
                        <mat-icon class="po-table__vendor-chevron">
                          keyboard_arrow_down
                        </mat-icon>
                      </div>
                      <mat-menu #menu="matMenu">
                        @if (isVendorListLoading(item)) {
                          <button class="import_btn" mat-menu-item disabled>
                            <span class="float_left f-14">Loading vendors…</span>
                          </button>
                        } @else {
                          @for (v of getVendorsFor(item); track v) {
                            <button class="import_btn" mat-menu-item
                              (click)="selectedVendor(item,v)">
                              <span class="float_left f-14">
                                {{v?.name}}
                              </span>
                            </button>
                          }
                          @if (!getVendorsFor(item).length) {
                            <button class="import_btn" mat-menu-item disabled>
                              <span class="float_left f-14">No vendors found</span>
                            </button>
                          }
                        }
                      </mat-menu>
                    </td>
                    <td class="text-black" [ngStyle]="{'background-color': item?.color}">
                      <span class="po-table__scope-cell">{{item?.scope_name}}</span></td>
                      <!-- Req 9: free stock, and what has been reserved off it for this job. -->
                      <!-- These four cells share one shape (.po-c): a strong value line and a quiet
                           line under it, with actions as small inline buttons or a ⋯ menu. Every
                           row stays two lines tall, whatever state the line is in. -->
                      <td class="text-black po-table__stock-cell" [ngStyle]="{'background-color': item?.color}">
                        @if (poReserved(item)) {
                          @let res = poReservations(item);
                          <div class="po-c__main">
                            <mat-icon class="po-c__ic po-c__ic--ok">inventory_2</mat-icon>
                            <b class="po-c__ok">{{ poReserved(item) }} reserved</b>
                            <button type="button" class="po-c__ib" [matMenuTriggerFor]="stockMenu"
                              matTooltip="Change or clear" aria-label="Reservation options"><mat-icon>more_horiz</mat-icon></button>
                            <!-- `class`, not `panelClass` — see the note on the Vendor Discount
                                 menu above; the input is aliased to `class` in this version. -->
                            <mat-menu #stockMenu="matMenu" xPosition="before" class="po-row-menu">
                              <button mat-menu-item (click)="openPoReserve(item)"><mat-icon>edit</mat-icon><span>Change reservation</span></button>
                              <button mat-menu-item (click)="clearPoReserve(item, $event)"><mat-icon>close</mat-icon><span>Clear reservation</span></button>
                            </mat-menu>
                          </div>
                          <div class="po-c__meta" [title]="res.length === 1 ? res[0].wh : ''">
                            {{ res.length === 1 ? res[0].wh : res.length + ' warehouses' }}
                            <!-- Where the shelf stock originally came from, so the buyer can see
                                 it was bought before rather than adjusted in by hand. -->
                            @if (poStockSourceLabel(item)) {
                              <span class="po-c__src" matTooltip="The purchase order this warehouse stock originally arrived on.">· {{ poStockSourceLabel(item) }}</span>
                            }
                          </div>
                        } @else if (poFreeStock(item)) {
                          <div class="po-c__main">
                            <b>{{ poFreeStock(item) }}</b><span class="po-c__unit">free</span>
                            <button type="button" class="po-c__btn po-c__btn--ok" [disabled]="!item.isSelected"
                              [matTooltip]="item.isSelected ? 'Take it from the warehouse instead of ordering it' : 'Select the line to reserve stock'"
                              (click)="openPoReserve(item)"><mat-icon>add</mat-icon>Reserve</button>
                          </div>
                          <div class="po-c__meta">
                            In {{ poStock(item).length }} warehouse{{ poStock(item).length === 1 ? '' : 's' }}
                            @if (poStockSourceLabel(item)) {
                              <span class="po-c__src" matTooltip="The purchase order this warehouse stock originally arrived on.">· {{ poStockSourceLabel(item) }}</span>
                            }
                          </div>
                        } @else {
                          <div class="po-c__main"><span class="po-c__muted">None free</span></div>
                          <div class="po-c__meta">Order it all</div>
                        }
                      </td>
                      <!-- The big number is what this PO orders (need − reserved), not item.quantity. -->
                      <td class="po-table__order-qty-cell" [ngStyle]="{'background-color': item.color}">
                        <div class="po-c__main po-c__main--c">
                          <!-- All from stock: nothing is ordered, so only the need shows, struck out. -->
                          @if (poCoveredByStock(item)) {
                            <s class="po-c__num po-c__off">{{ item?.quantity }}</s>
                          } @else {
                            @if (poReserved(item)) {
                              <s class="po-c__was">{{ item?.quantity }}</s>
                            }
                            <b class="po-c__num">{{ poOrderQty(item) }}</b>
                          }
                          @if (purchaseOrderObject.price_engineering_flag) {
                            <input
                              type="number" class="po-pe__qty"
                              [ngClass]="item.isSelected ? 'enabled' : 'disabled'"
                              [(ngModel)]="item.new_quantity" (change)="quantityChange(item)"
                              [ngModelOptions]="{standalone: true}" />
                          }
                        </div>
                        <div class="po-c__meta po-c__meta--c">
                          @if (poCoveredByStock(item)) {
                            <span class="po-c__ok">All from stock</span>
                          } @else if (poReserved(item)) {
                            <span class="po-c__ok">{{ poReserved(item) }} from stock</span>
                          } @else {
                            of {{ item?.quantity }} needed
                          }
                        </div>
                      </td>
                      <!-- The price paid buying now, with the catalog price struck through when a
                           quote beats it; the quiet line says where the price comes from, or what
                           reserved stock cost. -->
                      <td class="text-black po-table__unit-cost-cell" [ngStyle]="{'background-color': item?.color}">
                        <div class="po-c__main po-c__main--r">
                          <!-- All from stock: nothing is bought, so the buying price shows struck out. -->
                          @if (poCoveredByStock(item)) {
                            <s class="po-c__off">{{ poUnitCost(item) | currency:'USD' }}</s>
                          } @else {
                            @if (poQuote(item)) {
                              <s class="po-c__was">{{ poCatalogCost(item) | currency:'USD' }}</s>
                            }
                            <b>{{ poUnitCost(item) | currency:'USD' }}</b>
                          }
                        </div>
                        <div class="po-c__meta po-c__meta--r">
                          @if (poReserved(item)) {
                            <span class="po-c__ok"
                              [matTooltip]="poReserved(item) + ' from stock at ' + (poStockUnitCost(item) | currency:'USD') + ' = ' + (poStockValue(item) | currency:'USD')"
                              matTooltipPosition="above">Stock {{ poStockUnitCost(item) | currency:'USD' }}</span>
                          } @else if (poQuote(item)) {
                            <span class="po-c__q">Quote price</span>
                            @if (poQuoteSaving(item); as s) { <span [class.po-c__ok]="s.save"> · {{ s.text }}</span> }
                          } @else {
                            Catalog price
                          }
                        </div>
                      </td>
                      <!-- Req 8: the quote carried from the proposal, or one added here by
                           uploading it or selecting an existing one (addPoQuote). -->
                      <td class="po-table__quote-cell" [ngStyle]="{'background-color': item?.color}">
                        @if (poQuote(item); as q) {
                          <div class="po-c__main">
                            <mat-icon class="po-c__ic po-c__ic--q">{{ q.uploaded ? 'upload_file' : 'request_quote' }}</mat-icon>
                            <b class="po-c__q"
                              [matTooltip]="q.uploaded ? 'Uploaded here for this PO' : 'Vendor quote this line is priced from'"
                              matTooltipPosition="above">{{ q.code }}</b>
                            <button type="button" class="po-c__ib" [matMenuTriggerFor]="quoteMenu"
                              matTooltip="Change or remove" aria-label="Quote options"><mat-icon>more_horiz</mat-icon></button>
                            <mat-menu #quoteMenu="matMenu" xPosition="before" class="po-row-menu">
                              <button mat-menu-item (click)="addPoQuote(item)"><mat-icon>swap_horiz</mat-icon><span>Change quote</span></button>
                              <button mat-menu-item (click)="poRemoveQuote(item, $event)"><mat-icon>link_off</mat-icon><span>Remove quote</span></button>
                            </mat-menu>
                          </div>
                          <div class="po-c__meta">Valid till {{ q.valid }}</div>
                        } @else {
                          <div class="po-c__main">
                            <span class="po-c__muted">No quote</span>
                            <button type="button" class="po-c__btn po-c__btn--q" (click)="addPoQuote(item)"
                              matTooltip="Upload a quote or pick an existing one"><mat-icon>add</mat-icon>Add</button>
                          </div>
                          <div class="po-c__meta" [class.po-c__warn]="poQuoteDropped(item)">
                            {{ poQuoteDropped(item) ? 'Vendor changed' : 'Catalog price' }}
                          </div>
                        }
                      </td>
                      <td class="po-table__contract-cost" [ngStyle]="{'background-color': item?.color}">
                      {{ item?.previous_quantity_total | currency:'USD' }}</td>
                      <!-- Stage 6.7 Phase 4: Estimated Vendor Tax (Read-only) -->
                      <td class="pt-4 text-black" [ngStyle]="{'background-color': item?.color}">
                        <span matTooltip="Estimated vendor tax from proposal" matTooltipPosition="above">
                          {{ (item.estimated_vendor_tax || 0) | currency: 'USD' }}
                        </span>
                      </td>
                      <!-- PE Previous Column -->
                      @if (purchaseOrderObject.price_engineering_flag) {
                        <!-- Contract price × the quantity this order buys. A line wholly covered by
                             warehouse stock buys nothing, so it has no price to engineer. -->
                        <td class="po-table__pe-previous-cell">
                          @if (poLineOrderedQty(item) > 0) {
                            <span class="po-table__pe-previous-value"
                              matTooltip="Contract price × quantity ordered" matTooltipPosition="above">
                              {{ poPePrevious(item) | currency:'USD' }}
                            </span>
                          } @else {
                            <span class="po-c__muted" matTooltip="All from stock — nothing is ordered">—</span>
                          }
                        </td>
                      }
                      <!-- PE New Column: the price this order pays — the quote or catalog price
                           until the buyer types a figure (syncPeNewTotals keeps it current). -->
                      @if (purchaseOrderObject.price_engineering_flag) {
                        <td class="po-table__pe-new-cell"
                          [ngClass]="{'po-table__pe-new-cell--variance': poLineOrderedQty(item) > 0 && poPeVaries(item)}">
                          @if (poLineOrderedQty(item) > 0) {
                            <div class="po-table__pe-new-wrapper">
                              <input currencyMask
                                [options]="{ prefix: '', thousands: ',', decimal: '.', precision:'2', align:'right' }"
                                (keyup)="onChangeItemTotal($event, item)"
                                class="po-pe__input"
                                [(ngModel)]="item.new_quantity_total"
                                [ngModelOptions]="{standalone: true}"
                                placeholder="New Price" />
                              @if (item.new_quantity_total < poPePrevious(item) - 0.005) {
                                <i class="fa fa-arrow-down text-success" aria-hidden="true"
                                  matTooltip="Below the contract price — a cost saving"></i>
                              } @else if (item.new_quantity_total > poPePrevious(item) + 0.005) {
                                <i class="fa fa-arrow-up text-danger" aria-hidden="true"
                                  matTooltip="Above the contract price — a cost escalation"></i>
                              }
                            </div>
                          } @else {
                            <span class="po-c__muted">—</span>
                          }
                        </td>
                      }
                      <!-- Actions column -->
                      <td class="po-table__actions-td" [ngStyle]="{'background-color': item?.color}">
                        <button mat-icon-button class="po-table__delete-btn" matTooltip="Remove item"
                          (click)="selectedMaterial(false, item, i)">
                          <mat-icon>delete_outline</mat-icon>
                        </button>
                      </td>
                    </tr>
                  }
                </tbody>
                <tfoot>
                  <tr class="bottom-table po-table__totals-row">
                    <!-- Spans checkbox → unit cost (8 columns); the empty cell after it sits under
                         VENDOR QUOTE, so the totals land under CONTRACT COST and EST. VENDOR TAX.
                         Keep in sync with the header row. -->
                    <td class="total" colspan="8">Total</td>
                    <td> </td>
                    <td>
                      <span class="po-table__total-badge" matTooltip="Total Contract Cost of All Items">{{ materialList?.length ? (calculation?.contract_price_total|currency:'USD') : '$0.00'}}</span>
                    </td>
                    <!-- Stage 6.7 Phase 4: Estimated Vendor Tax Total -->
                    <td>
                      <strong matTooltip="Total Estimated Vendor Tax" class="cursor-pointer">{{ getTotalEstimatedVendorTax() | currency:'USD' }}</strong>
                    </td>
                    @if (purchaseOrderObject.price_engineering_flag) {
                      <td class="po-table__pe-total-previous">
                        <span class="po-table__pe-total-badge--previous">
                          {{calculation?.previous_total | currency:'USD'}}
                        </span>
                      </td>
                    }
                    @if (purchaseOrderObject.price_engineering_flag) {
                      <td class="po-table__pe-total-new">
                        <span class="po-table__pe-total-badge--new">
                          {{calculation?.new_total | currency:'USD'}}
                        </span>
                      </td>
                    }
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <!-- G8: Empty state when no materials -->
            @if (!materialList?.length) {
              <div class="po-table__empty-state">
                <mat-icon>inventory_2</mat-icon>
                <p class="po-table__empty-title">No materials added</p>
                <p class="po-table__empty-subtitle">Select materials from the left panel to add them</p>
              </div>
            }
          </div>

          <!-- Vendor GROUP -->
          <div class="po-vendor-list__header">
            <div class="d-flex align-items-center gap-2">
              <span class="po-vendor-list__accent-bar"></span>
              <span class="title-under-line">Vendor PO List</span>
            </div>

            @if (vendorGroupList?.length) {
              <div class="d-flex justify-content-end">
                <div class="po-header__toggle">
                  <mat-slide-toggle [checked]="false" [ngModelOptions]="{standalone:true}"
                    (ngModelChange)="groupMaterialToggle()" [(ngModel)]="purchaseOrderObject.group_material_flag"
                  class="toggle_switch toggle_switch_new me-3">Group Material</mat-slide-toggle>
                </div>
              </div>
            }
          </div>
          <div class="create-vendor-container">
            <!-- For Vendor Group -->
            <app-vendor-group-panel
              [vendorGroupList]="vendorGroupList"
              [materialSplitGroupList]="materialSplitGroupList"
              [purchaseOrderObject]="purchaseOrderObject"
              [currencyMaskOptions]="currencyMaskOptions"
              [allSplitMaterialSelected]="allSplitMaterialSelected"
              [shippmentToggleFn]="shippmentToggle.bind(this)"
              [shippingChargesChangeFn]="shippingChargesChange.bind(this)"
              [vendorTaxChangeFn]="vendorTaxChange.bind(this)"
              [quoteAmountchangeFn]="quoteAmountchange.bind(this)"
              [removeVendorFn]="removeVendor.bind(this)"
              [allSplitMaterialSelectionFn]="allSplitMaterialSelection.bind(this)"
              [selectedSplitMaterialFn]="selectedSplitMaterial.bind(this)"
              [purchaseForm]="purchaseForm"
              [uniqueCodes]="getUniqueCodes()"
              (splitPO)="splitPO($event)"
            ></app-vendor-group-panel>

            <!-- For Separate PO -->
            @if (separatePOJobList?.length) {
              <app-vendor-group-panel
                [vendorGroupList]="separatePOJobList"
                [materialSplitGroupList]="materialSplitGroupList"
                [purchaseOrderObject]="purchaseOrderObject"
                [currencyMaskOptions]="currencyMaskOptions"
                [allSplitMaterialSelected]="allSplitMaterialSelected"
                [shippmentToggleFn]="shippmentToggle.bind(this)"
                [shippingChargesChangeFn]="shippingChargesChange.bind(this)"
                [vendorTaxChangeFn]="vendorTaxChange.bind(this)"
                [quoteAmountchangeFn]="quoteAmountchange.bind(this)"
                [removeVendorFn]="removeVendor.bind(this)"
                [allSplitMaterialSelectionFn]="allSplitMaterialSelection.bind(this)"
                [selectedSplitMaterialFn]="selectedSplitMaterial.bind(this)"
                [isSplitedItem]="true"
                [purchaseForm]="purchaseForm"
                (splitPO)="splitPO($event)"
                (undoSplit)="undoSplit($event)"
              ></app-vendor-group-panel>
            }

          </div>
        </form>
      </div>

      <!-- Right Panel -->
      <div class="po-right-panel">
        <!-- Job List -->
        @if (selectedJobList?.length  && purchaseOrderObject.type==='bulk') {
          <div class="po-right-panel__section">
            <div class="card m-b-30 card-wrapper-inner">
              <div class="po-summary__header">
                <mat-icon class="po-summary__header-icon">calculate</mat-icon>
                <span class="title-under-line">Job PO Summary </span>
              </div>
              <div class="mt-2 m-2">
                @for (item of selectedJobList; track item) {
                  <div>
                    <mat-expansion-panel #panel1>
                      <mat-expansion-panel-header [ngStyle]="{'background-color': item.color}">
                        <mat-panel-title class="ps-3">
                          {{item?.name}}
                        </mat-panel-title>
                        <mat-panel-description>
                          <mat-icon>{{ panel1.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                        </mat-panel-description>
                      </mat-expansion-panel-header>
                      <div class="mt-4">
                        <app-purchase-order-summary [calculation]="item.calculation"
                        title="Job P.O Summary"></app-purchase-order-summary>
                      </div>
                    </mat-expansion-panel>
                  </div>
                }
              </div>
            </div>
          </div>
        }

        <!-- Vendor Discount — above the summary it applies to (moved here from the header). -->
        <div class="po-right-panel__discount">
          <ng-container *ngTemplateOutlet="vendorDiscountTpl"></ng-container>
        </div>

        <!-- Vendor PO Summary Header (GAP 2) -->
        <div class="po-summary__header">
          <mat-icon class="po-summary__header-icon">calculate</mat-icon>
          <span class="po-summary__header-title">Vendor PO Summary</span>
        </div>

        <!-- Vendor List (GAP 2/3/5) -->
        <div class="po-summary__vendors">
          @if (vendorGroupList?.length) {
            @for (item of vendorGroupList; track item) {
              <div>
                <mat-expansion-panel #panel1>
                  <!-- hideToggle: the template supplies its own chevron below.
                       Without this Material also renders `.mat-expansion-indicator`,
                       so two chevrons fought over the same corner. -->
                  <mat-expansion-panel-header hideToggle>
                    <mat-panel-title>
                      <span class="po-summary__vendor-name">{{item?.name}}</span>
                      <span class="po-vendor-badge">{{ item?.materialList?.length || 0 }} {{ (item?.materialList?.length || 0) === 1 ? 'item' : 'items' }}</span>
                    </mat-panel-title>
                    <mat-panel-description>
                      <span class="po-vendor-total">{{item?.calculation?.totalCost | currency:'USD'}}</span>
                      <mat-icon class="po-summary__chevron" [class.po-summary__chevron--expanded]="panel1.expanded">keyboard_arrow_down</mat-icon>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <div class="po-vendor-detail">
                    <div class="po-vendor-detail__row">
                      <span class="po-vendor-detail__label">Material Cost</span>
                      <span class="po-vendor-detail__value">{{item?.calculation?.materialCost | currency:'USD'}}</span>
                    </div>
                    <!-- Req 9: stock taken from the warehouse is already excluded from the
                         material cost above; this row says how much, so the figure is explicable. -->
                    @if (item?.calculation?.stockCredit > 0) {
                      <div class="po-vendor-detail__row po-vendor-detail__row--stock">
                        <span class="po-vendor-detail__label po-vendor-detail__label--stock"
                              matTooltip="Already owned and reserved from the warehouse, so it is not on this order and not included in the material cost above.">
                          <mat-icon class="po-vendor-detail__icon--stock">inventory_2</mat-icon> From Warehouse
                        </span>
                        <span class="po-vendor-detail__value po-vendor-detail__value--stock">{{item?.calculation?.stockCredit | currency:'USD'}}</span>
                      </div>
                    }
                    @if (item?.calculation?.costSaving > 0) {
                      <div class="po-vendor-detail__row po-vendor-detail__row--saving">
                        <span class="po-vendor-detail__label po-vendor-detail__label--green"><mat-icon class="po-vendor-detail__icon--down">trending_down</mat-icon> Cost Saving</span>
                        <span class="po-vendor-detail__value po-vendor-detail__value--green">-{{item?.calculation?.costSaving | currency:'USD'}}</span>
                      </div>
                    }
                    @if (item?.calculation?.cost_escalation > 0) {
                      <div class="po-vendor-detail__row po-vendor-detail__row--escalation">
                        <span class="po-vendor-detail__label po-vendor-detail__label--red"><mat-icon class="po-vendor-detail__icon--up">trending_up</mat-icon> Cost Escalation</span>
                        <span class="po-vendor-detail__value po-vendor-detail__value--red">+{{item?.calculation?.cost_escalation | currency:'USD'}}</span>
                      </div>
                    }
                    <div class="po-vendor-detail__row">
                      <span class="po-vendor-detail__label"><mat-icon class="po-vendor-detail__icon--truck">local_shipping</mat-icon> Shipping</span>
                      <span class="po-vendor-detail__value">{{item?.calculation?.shippingCharges | currency:'USD'}}</span>
                    </div>
                    <div class="po-vendor-detail__row po-vendor-detail__row--total">
                      <span class="po-vendor-detail__label">Total</span>
                      <span class="po-vendor-detail__value po-vendor-detail__value--bold">{{item?.calculation?.totalCost | currency:'USD'}}</span>
                    </div>
                  </div>
                </mat-expansion-panel>
              </div>
            }
          } @else {
            <div class="po-summary-empty">
              <mat-icon class="po-summary-empty__icon">inventory_2</mat-icon>
              <p class="po-summary-empty__text">Select materials to see summary</p>
            </div>
          }
          @if (separatePOJobList?.length) {
            @for (item of separatePOJobList; track item) {
              <div>
                <mat-expansion-panel #panel1>
                  <!-- hideToggle: the template supplies its own chevron below.
                       Without this Material also renders `.mat-expansion-indicator`,
                       so two chevrons fought over the same corner. -->
                  <mat-expansion-panel-header hideToggle>
                    <mat-panel-title>
                      <span class="po-summary__vendor-name">{{item?.name}}</span>
                      <span class="po-vendor-badge">{{ item?.materialList?.length || 0 }} {{ (item?.materialList?.length || 0) === 1 ? 'item' : 'items' }}</span>
                    </mat-panel-title>
                    <mat-panel-description>
                      <span class="po-vendor-total">{{item?.calculation?.totalCost | currency:'USD'}}</span>
                      <mat-icon class="po-summary__chevron" [class.po-summary__chevron--expanded]="panel1.expanded">keyboard_arrow_down</mat-icon>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <div class="po-vendor-detail">
                    <div class="po-vendor-detail__row">
                      <span class="po-vendor-detail__label">Material Cost</span>
                      <span class="po-vendor-detail__value">{{item?.calculation?.materialCost | currency:'USD'}}</span>
                    </div>
                    <!-- Req 9: stock taken from the warehouse is already excluded from the
                         material cost above; this row says how much, so the figure is explicable. -->
                    @if (item?.calculation?.stockCredit > 0) {
                      <div class="po-vendor-detail__row po-vendor-detail__row--stock">
                        <span class="po-vendor-detail__label po-vendor-detail__label--stock"
                              matTooltip="Already owned and reserved from the warehouse, so it is not on this order and not included in the material cost above.">
                          <mat-icon class="po-vendor-detail__icon--stock">inventory_2</mat-icon> From Warehouse
                        </span>
                        <span class="po-vendor-detail__value po-vendor-detail__value--stock">{{item?.calculation?.stockCredit | currency:'USD'}}</span>
                      </div>
                    }
                    @if (item?.calculation?.costSaving > 0) {
                      <div class="po-vendor-detail__row po-vendor-detail__row--saving">
                        <span class="po-vendor-detail__label po-vendor-detail__label--green"><mat-icon class="po-vendor-detail__icon--down">trending_down</mat-icon> Cost Saving</span>
                        <span class="po-vendor-detail__value po-vendor-detail__value--green">-{{item?.calculation?.costSaving | currency:'USD'}}</span>
                      </div>
                    }
                    @if (item?.calculation?.cost_escalation > 0) {
                      <div class="po-vendor-detail__row po-vendor-detail__row--escalation">
                        <span class="po-vendor-detail__label po-vendor-detail__label--red"><mat-icon class="po-vendor-detail__icon--up">trending_up</mat-icon> Cost Escalation</span>
                        <span class="po-vendor-detail__value po-vendor-detail__value--red">+{{item?.calculation?.cost_escalation | currency:'USD'}}</span>
                      </div>
                    }
                    <div class="po-vendor-detail__row">
                      <span class="po-vendor-detail__label"><mat-icon class="po-vendor-detail__icon--truck">local_shipping</mat-icon> Shipping</span>
                      <span class="po-vendor-detail__value">{{item?.calculation?.shippingCharges | currency:'USD'}}</span>
                    </div>
                    <div class="po-vendor-detail__row po-vendor-detail__row--total">
                      <span class="po-vendor-detail__label">Total</span>
                      <span class="po-vendor-detail__value po-vendor-detail__value--bold">{{item?.calculation?.totalCost | currency:'USD'}}</span>
                    </div>
                  </div>
                </mat-expansion-panel>
              </div>
            }
          }
        </div>

        <!-- Global Cost Breakdown (GAP 9) -->
        <!-- Split groups live in separatePOJobList and become POs too, so the panel must
             also show when every material has been split off the main vendor groups. -->
        @if (vendorGroupList?.length || separatePOJobList?.length) {
          <div class="po-right-panel__section po-breakdown__section">
            <div class="po-breakdown__label">COST BREAKDOWN</div>
            <div class="po-breakdown__grid">
              <div class="po-breakdown__card po-breakdown__card--material">
                <div class="po-breakdown__card-value">{{getGlobalMaterialCost() | currency:'USD'}}</div>
                <div class="po-breakdown__card-label">MATERIAL COST</div>
              </div>
              <div class="po-breakdown__card po-breakdown__card--saving">
                <div class="po-breakdown__card-value">{{getGlobalCostSaving() | currency:'USD'}}</div>
                <div class="po-breakdown__card-label">COST SAVING</div>
              </div>
              <div class="po-breakdown__card po-breakdown__card--shipping">
                <div class="po-breakdown__card-value">{{getGlobalShipping() | currency:'USD'}}</div>
                <div class="po-breakdown__card-label">SHIPPING</div>
              </div>
              <div class="po-breakdown__card po-breakdown__card--escalation">
                <div class="po-breakdown__card-value">{{getGlobalEscalation() | currency:'USD'}}</div>
                <div class="po-breakdown__card-label">ESCALATION</div>
              </div>
            </div>
            <!-- Orange Gradient Total Bar -->
            <div class="po-breakdown__total-bar">
              <div class="po-breakdown__total-section">
                <div class="po-breakdown__total-label">SUBTOTAL</div>
                <div class="po-breakdown__total-value">{{getGlobalSubtotal() | currency:'USD'}}</div>
              </div>
              <div class="po-breakdown__total-arrow">&rarr;</div>
              <div class="po-breakdown__total-section po-breakdown__total-section--right">
                <div class="po-breakdown__total-label">TOTAL COST</div>
                <div class="po-breakdown__total-value po-breakdown__total-value--grand">{{getGlobalTotal() | currency:'USD'}}</div>
              </div>
            </div>
          </div>
        }

      </div>
    </div>


<!-- ══ Req 9: reserve free warehouse stock for this job ══
     A plain overlay rather than a component of its own: this is the UI pass, and the dialog has
     no life outside the row it was opened from. ProSuite dialog chrome — navy header, orange
     underline — as the mockup has it. -->
@if (poResDlg) {
  <div class="po-res__backdrop" (click)="$event.target === $event.currentTarget && (poResDlg = null)">
    <div class="po-res" role="dialog" aria-modal="true" aria-label="Reserve from warehouse">
      <div class="po-res__head">
        <span class="po-res__icon"><mat-icon>inventory</mat-icon></span>
        <div class="po-res__title">
          <h4>Reserve from warehouse</h4>
          <p>{{ poResDlg.item?.product_name }}</p>
        </div>
        <button type="button" class="po-res__x" (click)="poResDlg = null" aria-label="Close">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="po-res__body">
        <div class="po-res__kv">
          <div><span>Needed on this job</span><b>{{ poResDlg.need }}</b></div>
          <div class="po-res__kv--good"><span>Free in warehouse</span><b>{{ poFreeStock(poResDlg.item) }}</b></div>
          <div><span>Reserving now</span><b>{{ poResTotal }}</b></div>
        </div>

        <table class="po-res__table">
          <thead>
            <tr><th>Warehouse</th><th>Bin</th><th class="r">Free</th><th class="r">Reserve</th></tr>
          </thead>
          <tbody>
            @for (row of poResDlg.rows; track row.wh) {
              <tr>
                <td>
                  {{ row.wh }}
                  @if (row.src) {
                    <!-- Provenance: the order this stock was originally bought on. -->
                    <span class="po-res__src">Received on {{ row.src }}</span>
                  }
                  @if (row.held) {
                    <span class="po-res__held">{{ row.held }} held for {{ row.heldFor }}</span>
                  }
                </td>
                <td>{{ row.bin }}</td>
                <td class="r">{{ row.free }}</td>
                <td class="r">
                  <input type="number" class="po-res__qty" min="0" [max]="poResMaxFor(row)"
                    [value]="row.q" (input)="poSetResQty(row, $any($event.target).value)"
                    [attr.aria-label]="'Reserve from ' + row.wh">
                </td>
              </tr>
            }
          </tbody>
        </table>

        <p class="po-res__note">
          Capped by the free stock in each warehouse and by what this job still needs.
          What you reserve comes off the order quantity — the PO only orders the rest.
        </p>
      </div>

      <div class="po-res__foot">
        <span class="po-res__sum">
          {{ poResTotal }} reserved · {{ (poResDlg.need - poResTotal) }} still to order
        </span>
        <button type="button" class="po-res__cancel" (click)="poResDlg = null">Cancel</button>
        <button type="button" class="po-res__ok" (click)="confirmPoReserve()">
          <mat-icon>check</mat-icon>Reserve
        </button>
      </div>
    </div>
  </div>
}
